import {
  SET_REBUILD_SEARCHING,
  SET_REBUILD_TASK_LIST_PAGE,
  SET_REBUILD_TASK_LIST_PAGE_TOTAL,
  SET_REBUILDEND_TASK_LIST_QUERY,
  SET_REBUILD_TASK_STATE_TYPE,
  SET_REBUILD_LIST_PAGE_SIZE,
  SET_REBUILD_SORT,
  SET_REBUILD_DATA,
  CHANGE_REBUILD_QUERY,
  SET_REBUILD_END_STATUS,
} from './mutation-types'
import api from '@/api'
import {objectTrim} from '@/utils'
import {TaskType} from '@/constants'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  taskTypes: [TaskType.Rebuild],
  statusFlag: '',      // [int option] 分析作业标识，0是运行的分析任务，1是完成的分析任务
  userName: '',        // [str option] 用户名
  userId: '',          // [str option] 用户id
  taskId: '',          // [int option] 平台作业id
  status: '',          // [int option] 状态
  areaId: '',          // [int option] 区域
  analyseIdSort: '',   // [int option] 分析任务id排序字段，0：降序，1：升序
  submitTimeFlag: '',  // [int option] 提交时间排序字段，0：降序，1：升序
  startTimeSort: '',   // [int option] 开始时间排序字段，0：降序，1：升序
  endTimeFlag: '',     // [int option] 结束时间排序字段，0：降序，1：升序
  statusSort: '',      // [int option] 状态排序字段，0：降序，1：升序
  keywords: '',
})

const rebuildRunning = () => ({
  list: [],
  listPageTotal: 0,
  query: initQuery(),
  sort: {
    submitTimeFlag: 0,
  },
})

const rebuildEnd = () => ({
  list: [],
  listPageTotal: 0,
  query: initQuery(),
  sort: {
    endTimeFlag: 0,
  },
})

const state = {
  rebuildEnd: rebuildEnd(),
  rebuildRunning: rebuildRunning(),
  initQuery: initQuery(),
  groups: [],
  stateType: {},
  initPageSize: 50,
  rebuildRunningStatus: [],
  rebuildEndStatus: [],
  searching: false,
}

const mutations = {
  [SET_REBUILD_DATA] (state, payload) {
    state.stateType.list = payload
  },
  [SET_REBUILD_TASK_LIST_PAGE] (state, payload) {
    state.stateType.query.pageNum = payload
  },
  [SET_REBUILD_TASK_LIST_PAGE_TOTAL] (state, payload) {
    state.stateType.listPageTotal = payload
  },
  [SET_REBUILD_LIST_PAGE_SIZE] (state, payload) {
    state.stateType.query.pageSize = payload
  },
  [SET_REBUILDEND_TASK_LIST_QUERY] (state, payload) {
    state.stateType.query = {
      ...state.stateType.query,
      ...payload,
    }
  },
  [SET_REBUILD_TASK_STATE_TYPE] (state, payload) {
    state.stateType = payload
  },
  [SET_REBUILD_SORT] (state, payload) {
    state.stateType.sort = payload
  },
  [SET_REBUILD_END_STATUS] (state, payload) {
    state.rebuildEndStatus = payload
  },
  [SET_REBUILD_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [CHANGE_REBUILD_QUERY] (state, payload) {
    const taskFlag = payload.taskFlag === 0 ? 'rebuildRunning' : 'rebuildEnd'
    Reflect.deleteProperty(payload, 'taskFlag')
    state[taskFlag].query = {
      ...state[taskFlag].query,
      ...payload,
    }
  },
}

const actions = {
  // 获取state类型
  getStateType ({commit, state}, statusFlag) {
    switch (statusFlag) {
      case 0:
        commit(SET_REBUILD_TASK_STATE_TYPE, state.rebuildRunning)
        break
      case 1:
        commit(SET_REBUILD_TASK_STATE_TYPE, state.rebuildEnd)
        break
    }
  },
  // 获取运行/完成的分析作业列表
  async setRebuildTaskList ({commit, state, dispatch}, payload) {
    try {
      dispatch('getStateType', payload.statusFlag)
      let param = objectTrim({
        ...state.stateType.query,
        ...state.stateType.sort,
        taskFlag: payload.statusFlag,
        taskStatus: payload.status || state.stateType.query.status,
        taskTypes: [TaskType.Rebuild],
      })
      commit(SET_REBUILD_SEARCHING, true)
      const {data: {items, total}} = await api.dayanTaskApi.getBuildEndTaskList(param)
      commit(SET_REBUILD_SEARCHING, false)
      commit(SET_REBUILD_TASK_LIST_PAGE_TOTAL, total)
      commit(SET_REBUILD_DATA, items)
    } catch (error) {
      console.log(error)
      commit(SET_REBUILD_SEARCHING, false)
      commit(SET_REBUILD_TASK_LIST_PAGE_TOTAL, 0)
      commit(SET_REBUILD_DATA, [])
    }
  },
  // 初始化列表
  async initRebuildTaskList ({commit, dispatch, state}, payload) {
    let query = {
      userName: '',
      taskId: '',
      status: '',
      areaId: '',
    }
    commit(SET_REBUILD_LIST_PAGE_SIZE, state.initPageSize)
    await dispatch('filterQuery', {query: query, statusFlag: payload.statusFlag, taskTypes: [TaskType.Rebuild]})
  },
  // 分析作业列表翻页
  async changeRebuildTaskListPage ({commit, state, dispatch}, payload) {
    commit(SET_REBUILD_TASK_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setRebuildTaskList', payload)
    return Promise.resolve(true)
  },
  // 改变每页显示条数
  async changePageSize ({commit, dispatch}, payload) {
    dispatch('getStateType', payload.statusFlag)
    commit(SET_REBUILD_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeRebuildTaskListPage', {currentPage: 1, statusFlag: payload.statusFlag, noXHR: true, status: payload.status})
    return Promise.resolve(true)
  },
  // 分析作业列表筛选
  async changeAnalyseTaskMessageQuery ({commit, dispatch}, statusFlag) {
    await dispatch('changeRebuildTaskListPage', {currentPage: 1, statusFlag: statusFlag})
  },
  // 列表表头筛选
  async filterQuery ({commit, dispatch}, payload) {
    dispatch('getStateType', payload.statusFlag)
    await dispatch('changeRebuildTaskListPage', {currentPage: 1, statusFlag: payload.statusFlag, status: payload.query.status, taskTypes: [TaskType.Rebuild]})
  },
  // 筛选参数
  setAnalyseQuery ({commit, dispatch, state}, payload) {
    dispatch('getStateType', payload.taskFlag)
    commit(SET_REBUILDEND_TASK_LIST_QUERY, payload.query)
  },
  // 排序
  changeSort ({commit, dispatch}, payload) {
    commit(SET_REBUILD_SORT, payload.sort)
    dispatch('changeRebuildTaskListPage', {currentPage: 1, statusFlag: payload.statusFlag})
  },
  resetSort ({dispatch}, {statusFlag}) {
    dispatch('changeSort', {statusFlag})
  },
  // 获取日志详情
  async setAnalyseTaskLogDetails ({commit, state}, payload) {
    const {code, data} = await api.dayanTaskApi.getRebuildLog(payload)
    return code === 200 ? data : []
  },
  changeRebuildQuery ({commit}, payload) {
    commit(CHANGE_REBUILD_QUERY, payload)
  },
  // 清空黑名单
  async cleanAnalyseBlackList ({commit}, payload) {
    const data = await api.dayanTaskApi.cleanBlackList(payload)
    return data
  },
  // 停止状态
  async rebuildStopTask ({state}, payload) {
    const data = await api.dayanTaskApi.stopTask({taskIds: payload})
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
